import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Landing from "@/pages/Landing";
import { AdminAuthProvider } from "@/admin/AdminAuthContext";
import AdminLayout from "@/admin/AdminLayout";
import Overview from "@/admin/pages/Overview";
import Companies from "@/admin/pages/Companies";
import Users from "@/admin/pages/Users";
import Roles from "@/admin/pages/Roles";
import Departments from "@/admin/pages/Departments";
import Agents from "@/admin/pages/Agents";
import Invites from "@/admin/pages/Invites";
import Billing from "@/admin/pages/Billing";
import AuditLogs from "@/admin/pages/AuditLogs";
import Settings from "@/admin/pages/Settings";

import { UserAuthProvider } from "@/user/UserAuthContext";
import UserLogin from "@/user/UserLogin";
import ChangePassword from "@/user/ChangePassword";
import DemoIntro from "@/demo/DemoIntro";
import DemoChat from "@/demo/DemoChat";
import AppShell from "@/user/AppShell";
import RoleDashboard from "@/user/RoleDashboard";
import MyWorkspace from "@/user/workspace/MyWorkspace";
import CeoCommandCenter from "@/user/ceo/CeoCommandCenter";
import CeoDepartmentDetail from "@/user/ceo/CeoDepartmentDetail";
import { CeoChatRoute } from "@/user/ceo/CeoChat";
import BusinessScan from "@/user/ceo/BusinessScan";
import WsSubmissions from "@/user/workspace/Submissions";
import WsTasks from "@/user/workspace/Tasks";
import WsDocuments from "@/user/workspace/Documents";
import Profile from "@/user/Profile";
import UserSettings from "@/user/UserSettings";

import CompanyAdminLayout from "@/company-admin/CompanyAdminLayout";
import CaOverview from "@/company-admin/pages/Overview";
import CaCompanyProfile from "@/company-admin/pages/CompanyProfile";
import CaEmployees from "@/company-admin/pages/Employees";
import CaInvitations from "@/company-admin/pages/Invitations";
import CaDepartments from "@/company-admin/pages/Departments";
import CaRoles from "@/company-admin/pages/Roles";
import CaPermissions from "@/company-admin/pages/Permissions";
import CaSettings from "@/company-admin/pages/Settings";
import CaProfile from "@/company-admin/pages/Profile";
import InvitationAccept from "@/company-admin/InvitationAccept";

function App() {
    return (
        <div className="App">
            <AdminAuthProvider>
                <UserAuthProvider>
                    <BrowserRouter>
                        <Routes>
                            <Route path="/" element={<Landing />} />

                            {/* Admin */}
                            <Route path="/admin/login" element={<Navigate to="/login" replace />} />
                            <Route path="/admin" element={<AdminLayout />}>
                                <Route index element={<Overview />} />
                                <Route path="dashboard" element={<Overview />} />
                                <Route path="companies" element={<Companies />} />
                                <Route path="users" element={<Users />} />
                                <Route path="roles" element={<Roles />} />
                                <Route path="departments" element={<Departments />} />
                                <Route path="agents" element={<Agents />} />
                                <Route path="invites" element={<Invites />} />
                                <Route path="billing" element={<Billing />} />
                                <Route path="audit-logs" element={<AuditLogs />} />
                                <Route path="settings" element={<Settings />} />
                            </Route>

                            {/* Public interactive demo (no auth) */}
                            <Route path="/demo" element={<DemoIntro />} />
                            <Route path="/app/chat-demo" element={<DemoChat />} />

                            {/* User workspaces */}
                            <Route path="/login" element={<UserLogin />} />
                            <Route path="/change-password" element={<ChangePassword />} />
                            <Route path="/app/chat" element={<CeoChatRoute />} />
                            <Route path="/app" element={<AppShell />}>
                                <Route path="ceo" element={<CeoCommandCenter />} />
                                <Route path="business-scan" element={<BusinessScan />} />
                                <Route path="ceo/department/:dept" element={<CeoDepartmentDetail />} />
                                <Route path="sales" element={<RoleDashboard role="sales" />} />
                                <Route path="finance" element={<RoleDashboard role="finance" />} />
                                <Route path="hr" element={<RoleDashboard role="hr" />} />
                                <Route path="operations" element={<RoleDashboard role="operations" />} />
                                <Route path="marketing" element={<RoleDashboard role="marketing" />} />
                                <Route path="customer-support" element={<RoleDashboard role="customer" />} />
                                <Route path="procurement" element={<RoleDashboard role="procurement" />} />
                                <Route path="legal" element={<RoleDashboard role="legal" />} />
                                <Route path="strategy" element={<RoleDashboard role="strategy" />} />
                                <Route path="meeting-admin" element={<RoleDashboard role="meeting" />} />

                                <Route path="workspace" element={<MyWorkspace />} />
                                <Route path="submissions" element={<WsSubmissions />} />
                                <Route path="tasks" element={<WsTasks />} />
                                <Route path="documents" element={<WsDocuments />} />

                                <Route path="profile" element={<Profile />} />
                                <Route path="settings" element={<UserSettings />} />
                            </Route>

                            {/* Company Admin */}
                            <Route path="/company-admin/login" element={<Navigate to="/login" replace />} />
                            <Route path="/company-admin" element={<CompanyAdminLayout />}>
                                <Route path="dashboard" element={<CaOverview />} />
                                <Route path="company" element={<CaCompanyProfile />} />
                                <Route path="employees" element={<CaEmployees />} />
                                <Route path="invitations" element={<CaInvitations />} />
                                <Route path="departments" element={<CaDepartments />} />
                                <Route path="roles" element={<CaRoles />} />
                                <Route path="permissions" element={<CaPermissions />} />
                                <Route path="settings" element={<CaSettings />} />
                                <Route path="profile" element={<CaProfile />} />
                            </Route>

                            {/* Public invitation activation */}
                            <Route path="/invitations/:token" element={<InvitationAccept />} />

                            <Route path="*" element={<Navigate to="/" replace />} />
                        </Routes>
                    </BrowserRouter>
                </UserAuthProvider>
            </AdminAuthProvider>
        </div>
    );
}

export default App;
